import { GeneralCargoStockOccupanciesApi } from '../api'
import { createApiClient } from '../http-client'

class GeneralCargoDamageService {
  httpClient = createApiClient(GeneralCargoStockOccupanciesApi)

  async getOrderDamageAmount(orderIds: number[]) {
    const { data } = await this.httpClient.generalCargoStockOccupanciesGetDamagesByOrderIds({ orderIds })

    return data
  }

  async getOrderDamage(orderId: number) {
    const { data } = await this.httpClient.generalCargoStockOccupanciesGetDamageInfoByOrderId({ orderId })

    return data
  }
}

export default new GeneralCargoDamageService()
